module.exports = __webpack_public_path__ + "static/media/Logo.8b13ad48.PNG";